// 文章校正機能のエントリポイント
//
// main.js からこう使う:
//   import { registerProofreading } from "@/proofreading";
//   registerProofreading(Vue);
//
// これで全ての <el-input type="textarea"> に v-proofread を付けられるようになる。

import proofreadDirective from './directives/proofread'
import './styles/proofread.css'

export function registerProofreading(Vue) {
  Vue.directive('proofread', proofreadDirective)
}
